import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";
import { ConstellationBackgroundLayer } from "@/components/constellation-background/ConstellationBackgroundLayer";
import { CONSTELLATION_BACKGROUND_ROOT_ID, useSelectConstellationBackgroundStore } from "./ConstellationBackgroundStore";
export function ConstellationBackground() {
  const $ = _c(8);
  const [open, backgrounds, hasBackgroundWithId, getTopLevelBackgroundId, setBackgroundVisibility] = useSelectConstellationBackgroundStore(useShallow(_temp));
  let t0;
  if ($[0] !== getTopLevelBackgroundId || $[1] !== hasBackgroundWithId || $[2] !== setBackgroundVisibility) {
    t0 = () => {
      if (hasBackgroundWithId(CONSTELLATION_BACKGROUND_ROOT_ID) && !getTopLevelBackgroundId()) {
        setBackgroundVisibility(CONSTELLATION_BACKGROUND_ROOT_ID, true);
      }
    };
    $[0] = getTopLevelBackgroundId;
    $[1] = hasBackgroundWithId;
    $[2] = setBackgroundVisibility;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== open) {
    t1 = [open];
    $[4] = open;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  useEffect(t0, t1);
  let t2;
  if ($[6] !== backgrounds) {
    t2 = backgrounds.map(_temp2);
    $[6] = backgrounds;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function _temp2(background) {
  return <ConstellationBackgroundLayer background={background} key={background.id} />;
}
function _temp(state) {
  return [state.open, state.backgrounds, state.hasBackgroundWithId, state.getTopLevelBackgroundId, state.setBackgroundVisibility];
}